module.exports = __webpack_public_path__ + "img/bk1.0a029948.jpg";